import React, { useEffect } from "react";

import { useParams } from "react-router-dom";
import { fetchWopiAssetDetails } from "src/redux/actions/microsoftWopiIntegration";
import AuthService from "src/services/auth.service";
import Loading from "src/components/loading";
import { useDispatch, useSelector } from "react-redux";

import _ from "lodash";
import styles from "./office.module.scss"
import EmptyMessage from "src/components/emptyMessage";

interface MicrosoftWopiIntegrationProps {

}

const MicrosoftWopiIntegration: React.FC<MicrosoftWopiIntegrationProps> = ({

}) => {

  const dispatch = useDispatch();
  const params = useParams();
  const assetId = params.assetId;

  const wopiDetails = useSelector((state: any) => _.get(state, "microsoftWopiIntegration.item", null));
  const loading = useSelector((state: any) => _.get(state, "microsoftWopiIntegration.loading", true));

  const actionUrl = wopiDetails ? `${wopiDetails.actionUrl}&wopisrc=${wopiDetails.wopiSrcUrl}&access_token=${AuthService.getAccessToken()}` : null;

  const errors = useSelector((state: any) => _.get(state, "microsoftWopiIntegration.errors", []));


  const initialiseIFrame = () => {
    var frameholder = document.getElementById('frameholder');
    var office_frame = document.createElement('iframe');
    office_frame.name = 'office_frame';
    office_frame.id = 'office_frame';
    office_frame.classList.add(styles.officeFrame);
    // The title should be set for accessibility
    office_frame.title = 'Office Frame';
    // This attribute allows true fullscreen mode in slideshow view
    // when using PowerPoint's 'view' action.
    office_frame.setAttribute('allowfullscreen', 'true');
    // The sandbox attribute is needed to allow automatic redirection to the O365 sign-in page in the business user flow
    office_frame.setAttribute('sandbox', 'allow-scripts allow-modals allow-same-origin allow-forms allow-popups allow-top-navigation allow-popups-to-escape-sandbox');
    if (frameholder) {
      frameholder.appendChild(office_frame);
    }
    const officeForm = document.getElementById('office_form') as HTMLFormElement;
    if (officeForm) {
      officeForm.submit();
    }
  }

  useEffect(() => {
    if(assetId) {
      dispatch(fetchWopiAssetDetails({assetId: assetId}));
    }

  }, []);

  useEffect(() => {
    if(wopiDetails && wopiDetails.actionUrl) {
      initialiseIFrame();
    }
  }, [wopiDetails]);

  if(loading) {
    return <Loading />
  }

  if(!loading && !wopiDetails) {
    var error = errors[0];
    let heading = "";
    let message = ""
    if (error?.code == 31001) {
      heading= "Mmm... who moved my cheese?";
      message= "Sorry!  Someone passed you the wrong information. You were never supposed to see me :). Looks like this is not a Microsoft-supported file type.";
    } else if (error?.code == 10002) {
      heading=`Mmm... who moved my cheese?`;
      message=`Sorry!  Some one passed you the wrong information. You were never supposed to see me :). This asset does not exist any longer.`;
    } else if(error?.code == 10007) {
      heading = "Who sets these rules, anyway?";
      message = "I'm sorry! It seems like I'm not authorised to show what you are looking for. I hate disappointing you :(";
    }
    return (
      <EmptyMessage
        heading={heading}
        message={message}
      />
    );
  }

  return (
    <div className={styles.content}>
       <form  key="2" id="office_form" name="office_form" target="office_frame" action={actionUrl || ""} method="post">
          <input name="access_token" value={`${AuthService.getAccessToken()}`} type="hidden" />
          <input name="access_token_ttl" value={wopiDetails.accessTokenExpired} type="hidden" />
        </form>,
        <span key="3" id="frameholder"></span>
    </div>
  );
};

export default MicrosoftWopiIntegration;
